module.exports = {"numberOfTickets":"Select how many tickets you want:","selectQuantity":"Select how many tickets you want:","numberOfFlexpasses":"Select how many flexpasses you want:","addToCart":"Add to cart","checkout":"Checkout","credit":"Credit Ticket Sales To:","ticketSelection":"Ticket selection","selectArtist":"Select an Artist","noTickets":"No more tickets available"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/GeneralSeating/locales/en.json
// module id = 1165
// module chunks = 0